(() => {
  const initPopup = (popup) => {
    if (!popup || popup.__senPromoOpen) return;
    const panel = popup.querySelector('.sen-promo-popup__panel');
    const closeButton = popup.querySelector('.sen-promo-popup__close');
    const countdown = popup.querySelector('[data-popup-countdown]');
    const form = popup.querySelector('.sen-promo-popup__form');
    const result = form?.querySelector('[data-popup-form-result]')?.dataset.popupFormResult;
    const storageKey = 'sen-newsletter-popup-dismissed-v1';
    const subscribedKey = 'sen-newsletter-subscribed-v1';
    const pendingKey = 'sen-newsletter-pending-v1';
    const designMode = popup.dataset.editor === 'true';
    let previousFocus;
    let previousOverflow;
    let timer;
    let openTimeout;
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null'); } catch (_) {}
    const ownHash = form && location.hash === `#${form.id}`;
    const freshPending = pending && form && pending.formId === form.id && Number.isFinite(pending.time) && Date.now() - pending.time >= 0 && Date.now() - pending.time < 1800000;
    const ownResult = Boolean(result && (ownHash || (freshPending && !location.hash)));

    const subscribed = () => {
      if (popup.dataset.subscribed === 'true') return true;
      try { return localStorage.getItem(subscribedKey) === '1'; } catch (_) { return false; }
    };
    const readDismissal = () => {
      try { return Number(localStorage.getItem(storageKey)) || 0; } catch (_) { return 0; }
    };
    const saveDismissal = () => {
      if (designMode) return;
      try { localStorage.setItem(storageKey, String(Date.now())); } catch (_) {}
      if (popup.dataset.frequency === 'session') {
        try { sessionStorage.setItem(storageKey, '1'); } catch (_) {}
      }
    };
    const eligible = () => {
      if (designMode) return true;
      if (subscribed() || (result && !ownResult)) return false;
      if (popup.dataset.scope === 'home' && popup.dataset.template !== 'index') return false;
      const end = Date.parse(popup.dataset.deadline);
      if (Number.isFinite(end) && end <= Date.now()) return false;
      const elapsed = Date.now() - readDismissal();
      if (popup.dataset.frequency === 'day') return elapsed >= 86400000;
      if (popup.dataset.frequency === 'week') return elapsed >= 604800000;
      if (popup.dataset.frequency === 'session') {
        try { return sessionStorage.getItem(storageKey) !== '1'; } catch (_) { return true; }
      }
      return true;
    };
    const close = () => {
      if (popup.hidden) return;
      popup.hidden = true;
      document.body.style.overflow = previousOverflow;
      saveDismissal();
      if (previousFocus?.isConnected) previousFocus.focus();
    };
    const open = (force = false) => {
      if ((!force && !eligible()) || !popup.hidden) return;
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      const responseTarget = ownResult ? popup.querySelector('.sen-promo-popup__error, .sen-promo-popup__success') : null;
      (responseTarget || closeButton).focus({preventScroll:true});
    };

    popup.querySelectorAll('[data-popup-close]').forEach((element) => element.addEventListener('click', close));
    popup.querySelector('[data-popup-shop]')?.addEventListener('click', close);
    form?.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      try { sessionStorage.setItem(pendingKey, JSON.stringify({formId:form.id,time:Date.now()})); } catch (_) {}
    });
    popup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled])')].filter((element) => element.getClientRects().length > 0);
      if (!focusable.length) return;
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    if (countdown) {
      const end = Date.parse(popup.dataset.deadline);
      const renderTime = () => {
        const remaining = end - Date.now();
        if (!Number.isFinite(end) || remaining <= 0) {
          countdown.hidden = true;
          clearInterval(timer);
          if (remaining <= 0 && !popup.hidden && !ownResult) close();
          return;
        }
        countdown.hidden = false;
        const seconds = Math.floor(remaining / 1000);
        const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
        ['days','hours','minutes','seconds'].forEach((part,index) => { countdown.querySelector(`[data-${part}]`).textContent = String(values[index]).padStart(2,'0'); });
      };
      renderTime();
      if (!countdown.hidden) timer = setInterval(renderTime,1000);
    }

    popup.__senPromoOpen = () => open(designMode);
    popup.__senPromoDestroy = () => {
      clearTimeout(openTimeout);
      clearInterval(timer);
      if (!popup.hidden) document.body.style.overflow = previousOverflow;
    };
    if (ownResult) {
      try { sessionStorage.removeItem(pendingKey); } catch (_) {}
      if (result === 'success' && !designMode) {
        try { localStorage.setItem(subscribedKey,'1'); } catch (_) {}
      }
      open(true);
    } else if (eligible()) {
      openTimeout = window.setTimeout(() => open(), Math.max(0,(Number(popup.dataset.delay) || 0) - performance.now()));
    }
  };

  initPopup(document.getElementById('SenPromoPopup'));
  document.addEventListener('shopify:section:load', (event) => initPopup(event.target.querySelector('.sen-promo-popup')));
  document.addEventListener('shopify:section:select', (event) => event.target.querySelector('.sen-promo-popup')?.__senPromoOpen?.());
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelector('.sen-promo-popup')?.__senPromoDestroy?.());
})();
